<button
  mat-button
  [matMenuTriggerFor]="profileMenu"
  [disableRipple]="true"
  class="profile-menu-button"
>
  @if (user?.userImage?.imagePath) {
  <img
    class="w-8 h-8 rounded-full object-cover"
    [src]="user?.userImage?.imagePath"
    alt=""
  />
  } @else {
  <div
    class="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center text-sm font-medium text-secondary"
  >
    {{
        (user?.firstName?.[0] ?? "") + (user?.surName?.[0] ?? "") | uppercase
    }}
  </div>
  }

  <span class="font-medium text-secondary">
    {{ user?.firstName }} {{ user?.surName }}
  </span>
</button>

<mat-menu #profileMenu="matMenu" xPosition="before" class="profile-menu mt-4">
  <button
    mat-menu-item
    [routerLink]="['/manage-account']"
    [queryParams]="{ tab: 'bookings' }"
  >
    <div
      class="flex items-center gap-3 px-2 py-2 rounded-lg hover:bg-light-blue transition-colors w-full"
    >
      <img src="/icons/briefcase.svg" class="w-5 h-5" />
      <span>{{ "Manage_Account.My_Booking" | translate }}</span>
    </div>
  </button>

  <button mat-menu-item routerLink="/manage-account">
    <div
      class="flex items-center gap-3 px-2 py-2 rounded-lg hover:bg-light-blue transition-colors w-full"
    >
      <img src="/icons/setting.svg" class="w-5 h-5" />
      <span>{{ "Manage_Account.Manage_Account" | translate }}</span>
    </div>
  </button>

  <button mat-menu-item routerLink="/about">
    <div
      class="flex items-center gap-3 px-2 py-2 rounded-lg hover:bg-light-blue transition-colors w-full"
    >
      <img src="/icons/help-circle.svg" class="w-5 h-5" />
      <span>{{ "Manage_Account.Need_Help" | translate }}</span>
    </div>
  </button>

  <button mat-menu-item (click)="openPopupLogout()">
    <div
      class="flex items-center gap-3 px-2 py-2 rounded-lg hover:bg-light-blue transition-colors w-full"
    >
      <img src="/icons/logout.svg" class="w-5 h-5" />
      <span class="text-red-600">
        {{ "Profile.LogOut" | translate }}
      </span>
    </div>
  </button>
</mat-menu>

@if (popupIsOpen) { <app-popup-logout (close)="closePopup()" /> }
